
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import toStringTagSupport from './to-string-tag-support.js';
import classof$1 from './classof.js';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var classof = classof$1;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

export { objectToString as default };
//# sourceMappingURL=object-to-string.js.map
